import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DirecterzeugerAdmin from './pages/DirecterzeugerAdmin';
import AddDirekterzeuger from './pages/AddDirekterzeuger';
import ProfilAdmin from './pages/ProfilAdmin';
import Tasks from './pages/Tasks';
import ProducerFeedback from './pages/ProducerFeedback';
import UserSuggestions from './pages/UserSuggestions';
import UserSuggestionDetail from './pages/UserSuggestionDetail';
import PrivateRoute from './components/PrivateRoute';
import './assets/css/admin.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';

// Router component that waits for auth
function AuthenticatedRouter() {
  const { isInitialized, loading } = useAuth();

  return (
    <Router basename="/">
      {(!isInitialized || loading) && (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Wird geladen...</p>
        </div>
      )}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/direkterzeuger-admin" element={<DirecterzeugerAdmin />} />
          <Route path="/direkterzeuger-admin/add" element={<AddDirekterzeuger />} />
          <Route path="/profil-admin/:hofId" element={<ProfilAdmin />} />
          <Route path="/user-suggestions" element={<UserSuggestions />} />
          <Route path="/user-suggestions/:suggestionId" element={<UserSuggestionDetail />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/feedback/producer" element={<ProducerFeedback />} />
        </Route>
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AuthenticatedRouter />
    </AuthProvider>
  );
}

export default App;
